<template>
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9904 18.02C7.01435 18.02 2.98043 13.9861 2.98043 9.01C2.98043 4.03391 7.01435 0 11.9904 0C16.9665 0 21.0004 4.03391 21.0004 9.01C21.0004 13.9861 16.9665 18.02 11.9904 18.02Z"
      fill="#FF5C00" />
    <path
      d="M1.01043 16.95C1.34043 16.34 2.04043 16 2.98043 16C3.69043 16 4.30043 16.29 4.66043 16.79C5.02043 17.29 5.10043 17.96 4.88043 18.63C4.45043 19.93 3.70043 20.22 3.29043 20.27C3.23043 20.28 3.17043 20.28 3.10043 20.28C2.66043 20.28 1.98043 20.09 1.32043 19.1C0.790433 18.33 0.690433 17.56 1.01043 16.95Z"
      fill="#FF5C00" />
  </svg>
</template>